import { ReturnsPromise } from 'api/api';

import { TranslateICUFn } from '~src/commons/utils/translations/translate';
import { priceToString } from '~src/price/format';

export const returnAndExchangeMessagesBuilder = (
  translate: TranslateICUFn,
  returnPromise: ReturnsPromise
): string[] => {
  const {
    currency_code,
    return_cost,
    exchange_cost,
    exchanges_enabled,
    returns_enabled,
    return_time_days,
  } = returnPromise;

  const result: string[] = [];

  // Exchange message
  if (exchanges_enabled && currency_code) {
    if (exchange_cost === 0) {
      // Free exchange
      result.push(translate('widget.RETURNS_POLICY.FREE_EXCHANGE'));
    } else if (exchange_cost && exchange_cost > 0) {
      // Paid exchange
      result.push(
        translate('widget.RETURNS_POLICY.PAID_EXCHANGE', {
          cost: priceToString(exchange_cost),
          currency: currency_code,
        })
      );
    }
  }

  // Return message
  if (returns_enabled && currency_code) {
    if (return_cost === 0) {
      // Free return
      result.push(translate('widget.RETURNS_POLICY.FREE_RETURN'));
    } else if (return_cost && return_cost > 0) {
      // Paid return
      result.push(
        translate('widget.RETURNS_POLICY.PAID_RETURN', {
          cost: priceToString(return_cost),
          currency: currency_code,
        })
      );
    }
  }

  // Return/Exchange window message
  if (return_time_days) {
    if (returns_enabled && exchanges_enabled) {
      // Both returns and exchanges are enabled
      result.push(
        translate('widget.RETURNS_POLICY.EXCHANGE_OR_RETURN_TIME', {
          days: return_time_days,
        })
      );
    } else if (returns_enabled) {
      // Only returns are enabled
      result.push(
        translate('widget.RETURNS_POLICY.RETURN_TIME', {
          days: return_time_days,
        })
      );
    } else if (exchanges_enabled) {
      // Only exchanges are enabled
      result.push(
        translate('widget.RETURNS_POLICY.EXCHANGE_TIME', {
          days: return_time_days,
        })
      );
    }
  }

  return result;
};
